import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Utils } from "@/shared/utils/utils";
import store from "@/store";
import { Http } from "@status/codes";
import { AxiosError } from "axios";
import lodash from "lodash";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
import { DashboardTemplateResponse } from "../../models/DashboardTemplateResponse";
import { FilterItemOfQuery } from "../../models/FilterItemOfQuery";
import {
  FilterField,
  FilterOfCollection
} from "../../models/FilterOfCollection";
import { IndicatorOrTag } from "../../models/IndicatorOrTag";
import { PropertiesToChart } from "../../models/PropertiesToChart";
import { Query } from "../../models/Query";
import {
  CollectionsOptions,
  SectionOfDashboard
} from "../../models/SectionOfDashboard";
import { ViewsConfigResponse } from "../../models/viewsConfigResponse";
import { BqDashboardService } from "../../services/BqDashboardService";
import Charts from "../Charts/Charts.vue";
import ChartTypeMenu from "../ChartTypeMenu/ChartTypeMenu.vue";
import FiltersModal from "../FiltersModal/FiltersModal.vue";
import IndicatorView from "../IndicatorView/IndicatorView.vue";

@Component({
  name: "DashboardView",
  components: {
    Charts,
    draggable,
    IndicatorView,
    DynamicSelect,
    ChartTypeMenu,
    FiltersModal
  },
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard"
    })
  }
})
export default class DashboardView extends Vue {
  @Inject() bqDashboardService!: BqDashboardService;

  @Prop() realDashboard?: boolean;
  @Prop() dashboardTemplate?: DashboardTemplateResponse;

  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  sectionsToChart: {
    index: number;
    name: string;
    propertiesToChart: (PropertiesToChart | IndicatorOrTag)[];
  }[] = [];
  template: DashboardTemplateResponse | undefined;
  collectionsData: ViewsConfigResponse[] = [];
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  showFilter = false;
  loading = false;
  filtersOfChartSelected: FilterOfCollection[] = [];
  collectionDataOfChartSelected: ViewsConfigResponse = {
    id: "",
    name: "",
    fields: []
  };
  currentCollectionFilterIndex = 0;
  currentSectionFilterIndex = 0;
  modalFilterData: {
    title: string;
  } | null = null;
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;

  async created() {
    if (this.realDashboard) {
      await this.getCollectionsOptions();
      this.renderRealDahsboard();
      return;
    }
    this.chart(this.sectionsOfDashboardStore);
  }

  chart(sectionsWithData: Array<SectionOfDashboard>) {
    this.sectionsToChart = lodash
      .cloneDeep(sectionsWithData)
      .map((section, indexSection) => {
        const propertiesToChart: (PropertiesToChart | IndicatorOrTag)[] = (
          section.collections || []
        ).map((collection, indexCollection) => {
          console.log("color", collection.chartColor);

          return {
            indexSectionOfDashboard: indexSection,
            indexCollectionFilter: indexCollection,
            groupBy: collection.groupBy,
            chartType: collection.chartType,
            uuid: Utils.idGenerator(),
            type: "chart",
            chartColor: { hex: collection.chartColor }
          };
        });

        if ((section.tags || []).length > 0) {
          (section.tags || []).forEach(tag => {
            if (!tag.show) return;
            tag.uuid = Utils.idGenerator();
            tag.type = "indicator";
            propertiesToChart.push(tag);
          });
        }

        if ((section.indicators || []).length > 0) {
          (section.indicators || []).forEach(indicator => {
            if (!indicator.show) return;
            indicator.uuid = Utils.idGenerator();
            indicator.type = "indicator";
            propertiesToChart.push(indicator);
          });
        }

        return {
          index: indexSection,
          name: section.name,
          propertiesToChart: propertiesToChart
        };
      });

    store.commit("setSectionsToChart", {
      sectionsToChart: this.sectionsToChart
    });
  }

  @Watch("dashboardTemplate")
  async renderRealDahsboard() {
    this.template = lodash.cloneDeep(this.dashboardTemplate);
    const sections = this.template?.sections ? this.template?.sections : [];
    for (const [indexSection, element] of sections.entries()) {
      element.collections.forEach((collection: any, indexCollection: any) => {
        this.getfieldsOfEveryCollection(indexSection, indexCollection);
        this.getData(
          collection.query as Query,
          indexSection,
          indexCollection,
          collection.chart.chartName
        );
      });

      for (const [indexTag, tag] of element.tags.entries()) {
        await this.queryTag(
          tag,
          indexSection,
          indexTag,
          (element.collections || [])?.[(element.collections || []).length - 1]
            ?.query as Query,
          tag.view as string
        );
      }
      (element.indicators || []).forEach((indicator, indexIndicator) => {
        const result = this.resolveIndicator(
          indexSection,
          indicator.formulaToCreateIndicator
        );
        this.template!.sections[indexSection].indicators[
          indexIndicator
        ].value = Number(result.toFixed(2));
      });
    }
  }

  resolveIndicator(indexSection: number, expresion: any) {
    let resultado = null;
    let operador = null;

    const valores = this.template!.sections[indexSection].tags.map(e => {
      return { id: e.indicatorOrTagName, value: e.value };
    });

    for (const item of expresion) {
      const token = item.id;
      const valueTag = valores.find(e => e.id == token);
      if (valueTag) {
        if (resultado === null) {
          resultado = valueTag.value;
        } else if (operador) {
          resultado = this.operar(resultado, operador, valueTag.value);
          operador = null;
        }
      } else {
        operador = token;
      }
    }

    return resultado;
  }

  operar(a: any, operador: any, b: any) {
    switch (operador) {
      case "+":
        return a + b;
      case "-":
        return a - b;
      case "*":
        return a * b;
      case "/":
        return b !== 0 ? a / b : null;
      default:
        throw new Error(`Operador no soportado: ${operador}`);
    }
  }

  async queryTag(
    tag: IndicatorOrTag,
    indexSection: number,
    indexTag: number,
    query: Query,
    view: string
  ) {
    query.selectFields.agregations = [
      {
        type: tag.operation as string,
        view: view,
        field: tag.field as string,
        alias: tag.field as string
      }
    ];
    query.groupFields = [];

    const response = await this.bqDashboardService.getDataToChart(query);
    this.template!.sections[indexSection].tags[indexTag].value =
      response.data[0][tag.field as string];
    this.updateDataInStore();
    this.chart(this.sectionsOfDashboardStore);
  }

  getfieldsOfEveryCollection(indexSection: number, indexCollection: number) {
    this.template!.sections[indexSection].collectionsOptions = (this
      .collectionsData as unknown) as CollectionsOptions[];
    this.template!.sections[indexSection].collections[
      indexCollection
    ].collection = this.collectionsData as [{ id: ""; name: ""; fields: [] }];
    this.template!.sections[indexSection].collections[
      indexCollection
    ].groupBy = this.template!.sections[indexSection].collections[
      indexCollection
    ].chart.groupBy;
    this.template!.sections[indexSection].collections[
      indexCollection
    ].seeBy = this.template!.sections[indexSection].collections[
      indexCollection
    ].chart.seeBy;
    this.template!.sections[indexSection].collections[
      indexCollection
    ].chartName = this.template!.sections[indexSection].collections[
      indexCollection
    ].chart.chartName;
    this.template!.sections[indexSection].collections[
      indexCollection
    ].chartData = {};
  }

  updateDataInStore() {
    store.commit("updateSectionsOfDashboard", this.template?.sections);
  }

  async getData(
    query: Query,
    indexSection: number,
    indexCollection: number,
    chartName: string
  ) {
    this.loading = true;
    const response = await this.bqDashboardService.getDataToChart(query);
    this.loading = false;

    response.data.xAxisValues, response.data.series, response.data.groups;

    const chartData = {
      chartName,
      xAxis: response.data.xAxisValues,
      data: response.data.series,
      groups: response.data.groups
    };

    this.template!.sections[indexSection].collections[
      indexCollection
    ].chartData = chartData;

    this.updateDataInStore();
    this.chart(this.sectionsOfDashboardStore);
  }

  async getCollectionsOptions() {
    try {
      const viewsConfig = await this.bqDashboardService.getViesConfig();

      if (viewsConfig.data) {
        this.collectionsData = viewsConfig.data;
        return;
      }
      Snackbar.popInfo(viewsConfig.message);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  openFilter(indexSection: number, indexCollection: number) {
    this.showFilter = true;
    this.currentCollectionFilterIndex = indexCollection;
    this.currentSectionFilterIndex = indexSection;
    this.filtersOfChartSelected = this.template!.sections[
      indexSection
    ].collections[indexCollection].filters;
    this.collectionDataOfChartSelected = this.collectionsData[indexCollection];
    this.modalFilterData = {
      title: this.template!.sections[indexSection].name
    };
  }

  onChartTypeChanged(
    newChartType: string,
    indexSection: number,
    indexCollection: number
  ) {
    const cloneSectionsToChart = lodash.cloneDeep(this.sectionsToChart);
    (cloneSectionsToChart[indexSection].propertiesToChart[
      indexCollection
    ] as PropertiesToChart).chartType = newChartType;
    this.sectionsToChart = cloneSectionsToChart;
  }

  async makeQuery() {
    this.showFilter = false;
    this.onChangeFilters();
  }

  async onChangeFilters() {
    this.dashboardTemplate?.sections!.forEach((element, indexSection) => {
      let lastQuery: Query;
      element.collections.forEach((collection, indexCollection) => {
        const collectionData = this.getCollectionDataByIndexCollection(
          indexSection,
          indexCollection
        );
        const filtersCloned = lodash.cloneDeep(
          this.sectionsOfDashboardStore[indexSection].collections[
            indexCollection
          ].filters
        );
        const filters = (filtersCloned.map(e => {
          return {
            field: (e.field[0] as FilterField).id,
            operator: (e.operator[0] as any).id,
            value: e.value.map((e: any) => e.id),
            view: collection.id
          };
        }) as unknown) as FilterItemOfQuery[];
        collectionData.query = {
          ...collection.query,
          filters
        } as Query;

        this.getData(
          collectionData.query,
          indexSection,
          indexCollection,
          collectionData.chartName
        );
        if (indexCollection == (element.collections || []).length - 1) {
          lastQuery = collectionData.query;
        }
      });

      (element.tags || []).forEach((tag, indexTag) => {
        this.queryTag(
          tag,
          indexSection,
          indexTag,
          lastQuery,
          tag.view as string
        );
      });
    });
  }

  getCollectionDataByIndexCollection(
    indexSection: number,
    indexCollection: number
  ) {
    const collection = this.dashboardTemplate?.sections[indexSection]
      .collections[indexCollection];
    return {
      query: collection?.query as Query,
      chartName: collection?.chartName as string
    };
  }
}
